import _Object$freeze from 'babel-runtime/core-js/object/freeze';
import { Roles } from './Roles';

export var PageRoles = _Object$freeze({
  NEW: [Roles.ADMIN, Roles.USER],
  IMPORT: [Roles.ADMIN],
  ANALYSE: [Roles.ADMIN],
  CUSTOMER: [Roles.ADMIN, Roles.USER],
  CASES: [Roles.ADMIN, Roles.USER],
  EXPORT: [Roles.ADMIN],
  BATCH: [Roles.ADMIN],
  ACTION: [Roles.ADMIN],
  ADMIN: [Roles.ADMIN]
});


// WEBPACK FOOTER //
// ./src/service/keycloak/PageRoles.js